import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { ArcadeProvider } from '@/arcade'
import { ErrorBoundary } from '@/components/ui/ErrorBoundary'
import { NavigationProvider } from '@/contexts/NavigationProvider'
import { ProgressProvider } from '@/contexts/ProgressProvider'
import { ShopProvider } from '@/contexts/ShopProvider'
import { GameProvider } from '@/contexts/GameProvider'
import { GameAudioProvider } from '@/contexts/GameAudioProvider'
import { TutorialProvider } from '@/contexts/TutorialProvider'
import { IAP_CATALOG } from '@/game/catalog'
import App from '@/App'
import '@fontsource/baloo-2/500.css'
import '@fontsource/baloo-2/700.css'
import '@fontsource/baloo-2/800.css'
import '@fontsource/nunito/400.css'
import '@fontsource/nunito/600.css'
import '@fontsource/nunito/700.css'
import '@fontsource/nunito/800.css'
import '@/styles/global.css'

const root = document.getElementById('root')
if (!root) throw new Error('Root element #root not found')

createRoot(root).render(
  <StrictMode>
    <ErrorBoundary>
      <ArcadeProvider gameId="take-me-home" monetization={{ catalog: IAP_CATALOG }}>
        <GameAudioProvider>
          <ProgressProvider>
            <ShopProvider>
              <GameProvider>
                <NavigationProvider initial="boot">
                  <TutorialProvider>
                    <App />
                  </TutorialProvider>
                </NavigationProvider>
              </GameProvider>
            </ShopProvider>
          </ProgressProvider>
        </GameAudioProvider>
      </ArcadeProvider>
    </ErrorBoundary>
  </StrictMode>,
)
